import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('./views/Home.vue'),
    },
    {
        path: '/manifesto',
        name: 'Manifesto',
        component: () => import('./views/Manifest.vue'),
    },
    {
        path: '/pages/:slug?',
        name: 'Page',
        component: () => import('./views/Article.vue'),
    },
    {
        path: '/not-found',
        name: 'NotFound',
        component: () => import('./views/NotFound.vue'),
    },
    {
        path: '*',
        // redirect: '/home',
        component: () => import('./views/NotFound.vue'),
    }
];

export default new Router({
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL || '/', 
    routes,
});